import { useState, useCallback } from 'react';
import { medicosAPI, tiposEstudiosAPI } from '../../../core/api/api';

// Clave de un canal de equipo: combinación (canales, conCpap).
export const claveCanal = (c) => `${c.canales}-${c.conCpap ? 1 : 0}`;

export const useTiposEstudios = () => {
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [categorias, setCategorias] = useState([]);
  // Canales que puede usar cada tipo de estudio: { [idTipoEstudio]: [{ canales, conCpap, etiqueta }] }
  const [canalesPorEstudio, setCanalesPorEstudio] = useState({});
  // Canales que existen según los equipos de todas las sedes: [{ canales, conCpap, etiqueta, equipos }]
  const [opcionesCanales, setOpcionesCanales] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarCanales = useCallback(async () => {
    try {
      const [rCanales, rOpciones] = await Promise.all([
        tiposEstudiosAPI.getCanalesTiposEstudio(),
        medicosAPI.getOpcionesCanales(),
      ]);
      const mapa = {};
      (rCanales.data || []).forEach(c => { mapa[c.idTipoEstudio] = [...(mapa[c.idTipoEstudio] || []), c]; });
      setCanalesPorEstudio(mapa);
      setOpcionesCanales(rOpciones.data || []);
    } catch {
      // Sin canales no se rompe la pantalla: solo no se muestran.
      setCanalesPorEstudio({});
      setOpcionesCanales([]);
    }
  }, []);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [estudiosRes, categoriasRes] = await Promise.all([
        tiposEstudiosAPI.getTiposEstudios(),
        tiposEstudiosAPI.getCategorias(),
      ]);
      setTiposEstudios(estudiosRes.data || []);
      setCategorias(categoriasRes.data || []);
    } finally {
      setLoading(false);
    }
    await cargarCanales();
  }, [cargarCanales]);

  // canales: [{ canales, conCpap }]
  const guardarCanales = useCallback(async (idTipoEstudio, canales) => {
    await tiposEstudiosAPI.guardarCanalesTipoEstudio(idTipoEstudio, canales);
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try { await tiposEstudiosAPI.guardarTipoEstudio(data); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try { await tiposEstudiosAPI.actualizarTipoEstudio(id, data); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try { await tiposEstudiosAPI.eliminarTipoEstudio(id); }
    finally { setLoading(false); }
  }, []);

  return { tiposEstudios, categorias, canalesPorEstudio, opcionesCanales, loading, cargar, guardar, actualizar, eliminar, guardarCanales };
};
